export const isUnknownRecord = u => {
  const s = Object.prototype.toString.call(u);
  return s === "[object Object]" || s === "[object Window]";
};
export const isString = u => typeof u === "string";
export const isNumber = u => typeof u === "number";
//# sourceMappingURL=common.mjs.map